import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 3.375C3.75 2.34 4.589 1.5 5.625 1.5H9C9.99456 1.5 10.9484 1.89509 11.6517 2.59835C12.3549 3.30161 12.75 4.25544 12.75 5.25V7.125C12.75 7.62228 12.9475 8.09919 13.2992 8.45083C13.6508 8.80246 14.1277 9 14.625 9H16.5C17.4946 9 18.4484 9.39509 19.1517 10.0983C19.8549 10.8016 20.25 11.7554 20.25 12.75V20.625C20.25 21.66 19.41 22.5 18.375 22.5H5.625C4.59 22.5 3.75 21.66 3.75 20.625V3.375ZM14.6519 12.659C14.9448 12.3661 14.9448 11.8912 14.6519 11.5983C14.359 11.3054 13.8841 11.3054 13.5912 11.5983L12.0002 13.1893L10.4092 11.5983C10.1163 11.3054 9.64147 11.3054 9.34858 11.5983C9.05568 11.8912 9.05568 12.3661 9.34858 12.659L10.9396 14.25L9.34858 15.841C9.05568 16.1339 9.05568 16.6087 9.34858 16.9016C9.64147 17.1945 10.1163 17.1945 10.4092 16.9016L12.0002 15.3106L13.5912 16.9016C13.8841 17.1945 14.359 17.1945 14.6519 16.9016C14.9448 16.6087 14.9448 16.1339 14.6519 15.841L13.0609 14.25L14.6519 12.659Z"
        fill={colorValue}
      />
      <path
        d="M14.25 5.25C14.2518 3.98855 13.7975 2.76896 12.971 1.816C14.6443 2.25596 16.1707 3.13247 17.3941 4.35589C18.6175 5.5793 19.494 7.10571 19.934 8.779C18.981 7.95248 17.7615 7.49825 16.5 7.5H14.625C14.418 7.5 14.25 7.332 14.25 7.125V5.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
